// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_container__3fyBr {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    row-gap: 12px;
    column-gap: 26px;
    position: relative;
}

/*.container*/
/*!*:not(:last-child) *! {*/
/*    margin-bottom: 35px;*/
/*}*/

.Input_container__3fyBr.Input_fullWidth__60kAn {
    width: 100%;
}

.Input_container__3fyBr.Input_textStyle__nxjpe {
    flex-direction: column;
    align-items: flex-start;
    /*width: 621px;*/
}

.Input_container__3fyBr.Input_secondary__ni-H- {
    display: grid;
    grid-template-columns: 1fr 300px;
}

.Input_afterInput__fajK1 {
    position: absolute;
    top: -12px;
    right: -12px;
}

.Input_offset__M5A7P:not(.Input_secondary__ni-H-) .Input_inputWrapper__oK-5b {
    max-width: calc(100% - 140px);
}

.Input_offset__M5A7P.Input_small__dvTS7 .Input_inputWrapper__oK-5b {
    max-width: calc(100% - 60px);
}

.Input_container__3fyBr.Input_hasInfo__-iNkE .Input_inputWrapper__oK-5b {
    max-width: 420px;
}

.Input_container__3fyBr:not(.Input_extended__UkVEC):not(.Input_textStyle__nxjpe):not(.Input_hasInfo__-iNkE):not(.Input_secondary__ni-H-) {
    max-width: 562px;
}

.Input_container__3fyBr.Input_full__dYpPd {
    width: 100%;
}

.Input_container__3fyBr.Input_offset__M5A7P {
    margin-bottom: 35px;
}

.Input_container__3fyBr p {
    margin: 0 0 0 auto;
    width: 300px;
    font-size: 14px;
}

.Input_inputWrapper__oK-5b > div:not(.Input_afterInput__fajK1) {
    width: 100%;
}

.Input_label__jk8\\+l {
    min-width: 116px;
    max-width: 116px;
    color: #7b848e;
    font-weight: bold;
    font-size: 10px;
    line-height: 16px;
}

.Input_label-sm__l2lGp {
    min-width: 80px;
    max-width: 80px;
}

.Input_labelInner__GpvUH {
    position: relative;
    display: inline-block;
}

.Input_afterLabel__ywMS- {
    position: absolute;
    margin-top: -16px;
    right: -26px;
    top: 0;
}

.Input_container__3fyBr.Input_small__dvTS7 .Input_label__jk8\\+l {
    min-width: 60px;
    max-width: 60px;
}

.Input_container__3fyBr:not(.Input_textStyle__nxjpe):not(.Input_secondary__ni-H-) .Input_label__jk8\\+l {
    text-transform: uppercase;
}

.Input_container__3fyBr.Input_textStyle__nxjpe .Input_label__jk8\\+l,
.Input_container__3fyBr.Input_secondary__ni-H- .Input_label__jk8\\+l {
    font-size: 16px;
    font-weight: 500;
    max-width: 100%;
}

.Input_labelFullWidth__yeP5E {
    max-width: 100%;
}

.Input_inputWrapper__oK-5b {
    position: relative;
    margin: auto 0;
    flex: 1 1;
    display: flex;
}

.Input_inputWrapper__oK-5b:after {
    content: attr(data-title);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 102%;
    background: #7b848e;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    color: #fff;
    width: max-content;
    max-width: 100%;
    opacity: 0;
    font-size: 10px;
    /*transition: opacity 0.25s ease-in-out;*/
}

.Input_activeTitle__opnwL .Input_inputWrapper__oK-5b:after {
    padding: 2px 4px;
}

.Input_active__UMLHi .Input_inputWrapper__oK-5b:hover:after {
    opacity: 1;
}

.Input_inputField__lQUCD {
    --input-h: 44px;

    border: 0.5px dashed #707070;
    border-radius: 2px;
    padding: 0 15px;
    line-height: 35px;

    /*padding: 13.5px 14px 13.5px 22px;*/
    min-height: var(--input-h) !important;
    max-height: var(--input-h);
    background-color: #fff;
    text-align: left;
    position: relative;
    /*max-width: 430px;*/
    width: 100%;
}

.Input_inputField__lQUCD.Input_readOnlySecondary__tD8Cc[readonly] {
    border: 0.5px dashed #707070;
}

.Input_inputField__lQUCD:not(.Input_readOnlySecondary__tD8Cc)[readonly] {
    border: 1px solid var(--primary-color-active);
}

.Input_selectField__Oy5S1 {
    border: 0.5px solid #707070;
    border-radius: 2px;
    padding: 0 15px;
    line-height: 35px;

    /*padding: 13.5px 14px 13.5px 22px;*/
    min-height: var(--input-h) !important;
    max-height: var(--input-h);
    background-color: #fff;
    text-align: left;
    position: relative;
    /*max-width: 430px;*/
    width: 100%;
}

.Input_inputField__lQUCD:not(.Input_inputFieldTextView__ZRfIt):not(textarea),
textarea.Input_readOnly__MPzMO {
    cursor: pointer !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.Input_inputField__lQUCD.Input_selected__0b6DD:not(.Input_focused__LUBdd) {
    border-color: var(--primary-color-active);
}

.Input_container__3fyBr.Input_active__UMLHi .Input_inputField__lQUCD {
    /*border-color: var(--primary-color-active);*/
}

.Input_inputField__lQUCD:not(.Input_focused__LUBdd):not(.Input_selected__0b6DD) {
    /*background-color: rgba(214, 214, 214, 0.1) !important;*/
}

.Input_selectField__Oy5S1.Input_focused__LUBdd {
    border-radius: 0;
    color: #7b848e;
}

.Input_inputField__lQUCD.Input_selected__0b6DD.Input_selectedMulti__lLnq3:not(.Input_focused__LUBdd) {
    background-color: #f0f3f7;
    color: var(--primary-color-active);
}

.Input_inputField__lQUCD.Input_multi__YVRas {
}

.Input_inputField__lQUCD.Input_disabled__lUbIG,
.Input_inputField__lQUCD:disabled {
    color: var(--light-grey);
    border-color: var(--light-grey) !important;
    background-color: rgba(214, 214, 214, 0.1);
}

.Input_inputField__lQUCD:not(.Input_disabled__lUbIG) svg {
    color: var(--primary-color-active);
}

.Input_inputWithNote__2Y9Ej {
    padding-right: 75px;
}

.Input_inputNote__1\\+LwH {
    position: absolute;
    right: 40%;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 14px;
    color: var(--dark-grey);
}

.Input_icon__UofWR {
    position: absolute;
    left: 15px;
    top: 12px;
    width: 20px;
}

.Input_iconRight__4Bnik {
    left: auto;
    right: 10px;
}

.Input_container__3fyBr.Input_secondary__ni-H- .Input_inputField__lQUCD {
    /*background: #efeff0;*/
}

.Input_container__3fyBr.Input_textStyle__nxjpe .Input_inputWrapper__oK-5b {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
}

.Input_container__3fyBr.Input_textStyle__nxjpe .Input_inputField__lQUCD {
    border-style: dotted;
    /*line-height: 40px;*/
    /*background-image: radial-gradient(#707070 2px, transparent 0);*/
    /*background-size: 2px 2px;*/
    /*background-position: -19px -19px;*/

    /*line-height: 24px;*/
    /*font-size: 16px;*/
    /*background-image: radial-gradient(circle at 0px 100%, rgb(0, 0, 0) 1px, transparent 1px);*/
    /*background-size: 6px 34px;*/

    /*background-image: url('../../assets/icons/dot.svg'), linear-gradient(to right, #707070 52px, transparent);*/

    /* Control pattern repetition and positioning */
    /*background-size: 6px 24px; !* 6px = horizontal dot spacing, 24px = line height *!*/
    /*background-position: 50px 0; !* Start pattern after 50px white space *!*/
    /*background-repeat: repeat;*/

    resize: none;
    /*height: 40px;*/
    /*min-height: 120px;*/
    max-height: unset;
    padding-left: 50px;
    width: 100%;
    line-height: 35px;
}

.Input_container__3fyBr.Input_textStyle__nxjpe .Input_bg__SZDbl,
.Input_container__3fyBr.Input_textPreview__NermP .Input_bg__SZDbl {
    position: absolute;
    display: block;
    top: 34px;
    left: 50px;
    width: calc(100% - 50px);
    height: 100%;
    background-image: radial-gradient(circle at 0.5px 0.5px, #7b848e 0.5px, transparent 0);
    background-size: 3px 35px;
    background-repeat: repeat;
    pointer-events: none;
}

.Input_container__3fyBr.Input_textPreview__NermP .Input_bg__SZDbl {
    left: 10px;
}

.Input_container__3fyBr.Input_textPreview__NermP {
    overflow: hidden;
}

textarea.Input_inputField__lQUCD {
    white-space: pre-wrap;
}

.Input_note__pleid {
    display: block;
    text-align: right;
    font-size: 16px;
    color: #7b848e;
    position: absolute;
    bottom: -18px;
    right: 0;
}

.Input_max__lThOe {
    display: grid;
    width: 100%;
    text-align: right;
    font-size: 16px;
    color: #707070;
    grid-template-columns: 120px 120px;
    justify-content: flex-end;
}

.Input_max__lThOe span:first-child {
    text-align: left;
}

.Input_info__806YQ {
    margin: 0 0 0 auto;
    max-width: 300px;
    font-size: 14px;
}

.Input_align-top__dUN7V {
    align-items: flex-start;
}

.Input_align-top__dUN7V .Input_label__jk8\\+l {
    margin-top: 12px;
}

.Input_inputField__lQUCD.Input_controlTop__magQr {
    z-index: 11;
    border-top-color: #fff;
}

.Input_inputField__lQUCD.Input_controlBottom__VFaQV {
    z-index: 11;
    border-bottom-color: #fff;
}

.Input_selectField__Oy5S1.Input_focused__LUBdd::after {
    content: '';
    display: block;
    border-top: 1px solid var(--light-grey);
    position: absolute;
    bottom: 0;
    width: calc(100% - 6px);
    left: 3px;
}

.Input_selectField__Oy5S1.Input_controlTop__magQr::after {
    bottom: initial;
    top: 0;
}

.Input_inputFieldTextView__ZRfIt {
    text-wrap: wrap;
    background-image: radial-gradient(circle at 0.5px 0.5px, #7b848e 0.5px, transparent 0);
    background-size: 3px 35px;
    background-repeat: repeat;
    background-position: 0 34px;
}

.Input_inputFieldViewContainer__xtQp\\+ {
    overflow: auto;
    max-height: calc(100vh - var(--header-height) - 500px);
}

.Input_inputFieldTextPreview__TpCdG {
    padding-top: 2px;
    padding-right: 40px;
}

.Input_inputFieldTextPreview__TpCdG.Input_selected__0b6DD {
}

.Input_inputFieldTextPreviewSmall__YL2Fy.Input_selected__0b6DD {
    font-size: 12px;
    line-height: 16px;
    padding-top: 6px;
    padding-bottom: 6px;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .Input_inputFieldTextPreview__TpCdG {
        padding-top: 0;
    }

    .Input_container__3fyBr.Input_offset__M5A7P
    /*:not(:last-child) */ {
        margin-bottom: 16px;
    }

    .Input_container__3fyBr:not(.Input_extended__UkVEC):not(.Input_textStyle__nxjpe):not(.Input_hasInfo__-iNkE):not(.Input_secondary__ni-H-) {
        max-width: 442px;
    }

    .Input_container__3fyBr:not(.Input_extended__UkVEC):not(.Input_textStyle__nxjpe) .Input_inputWrapper__oK-5b {
        max-width: 300px;
    }

    .Input_inputField__lQUCD {
        --input-h: 32px;
        /*min-height: 32px !important;*/
        /*max-height: 32px;*/
        /*padding: 12px 14px 12px 22px;*/
        /*padding: 10px 14px 10px 22px;*/
        font-size: 14px;
        line-height: 30px;
    }

    .Input_note__pleid {
        font-size: 14px;
    }

    .Input_container__3fyBr.Input_offset__M5A7P {
        margin-bottom: 26px;
    }

    .Input_icon__UofWR {
        top: 6px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/InputLabel/Input.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,aAAa;AACb,2BAA2B;AAC3B,2BAA2B;AAC3B,IAAI;;AAEJ;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;;IAEf,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;;IAEjB,oCAAoC;IACpC,qCAAqC;IACrC,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;;IAEjB,oCAAoC;IACpC,qCAAqC;IACrC,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;AACf;;AAEA;;IAEI,0BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;AACA;;AAEA;;IAEI,wBAAwB;IACxB,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,iEAAiE;IACjE,4BAA4B;IAC5B,oCAAoC;;IAEpC,qBAAqB;IACrB,mBAAmB;IACnB,4FAA4F;IAC5F,6BAA6B;;IAE7B,6GAA6G;;IAE7G,+CAA+C;IAC/C,oFAAoF;IACpF,0EAA0E;IAC1E,6BAA6B;;IAE7B,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,UAAU;IACV,wBAAwB;IACxB,YAAY;IACZ,sFAAsF;IACtF,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,uCAAuC;IACvC,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,MAAM;AACV;;AAEA;IACI,eAAe;IACf,sFAAsF;IACtF,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,sDAAsD;AAC1D;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;AACA;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,+BAA+B;QAC/B,oBAAoB;QACpB,gCAAgC;QAChC,gCAAgC;QAChC,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;AACJ","sourcesContent":["@value screen-lg-min, screen-md-max from '../../breakpoints.css';\n\n.container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    row-gap: 12px;\n    column-gap: 26px;\n    position: relative;\n}\n\n/*.container*/\n/*!*:not(:last-child) *! {*/\n/*    margin-bottom: 35px;*/\n/*}*/\n\n.container.fullWidth {\n    width: 100%;\n}\n\n.container.textStyle {\n    flex-direction: column;\n    align-items: flex-start;\n    /*width: 621px;*/\n}\n\n.container.secondary {\n    display: grid;\n    grid-template-columns: 1fr 300px;\n}\n\n.afterInput {\n    position: absolute;\n    top: -12px;\n    right: -12px;\n}\n\n.offset:not(.secondary) .inputWrapper {\n    max-width: calc(100% - 140px);\n}\n\n.offset.small .inputWrapper {\n    max-width: calc(100% - 60px);\n}\n\n.container.hasInfo .inputWrapper {\n    max-width: 420px;\n}\n\n.container:not(.extended):not(.textStyle):not(.hasInfo):not(.secondary) {\n    max-width: 562px;\n}\n\n.container.full {\n    width: 100%;\n}\n\n.container.offset {\n    margin-bottom: 35px;\n}\n\n.container p {\n    margin: 0 0 0 auto;\n    width: 300px;\n    font-size: 14px;\n}\n\n.inputWrapper > div:not(.afterInput) {\n    width: 100%;\n}\n\n.label {\n    min-width: 116px;\n    max-width: 116px;\n    color: #7b848e;\n    font-weight: bold;\n    font-size: 10px;\n    line-height: 16px;\n}\n\n.label-sm {\n    min-width: 80px;\n    max-width: 80px;\n}\n\n.labelInner {\n    position: relative;\n    display: inline-block;\n}\n\n.afterLabel {\n    position: absolute;\n    margin-top: -16px;\n    right: -26px;\n    top: 0;\n}\n\n.container.small .label {\n    min-width: 60px;\n    max-width: 60px;\n}\n\n.container:not(.textStyle):not(.secondary) .label {\n    text-transform: uppercase;\n}\n\n.container.textStyle .label,\n.container.secondary .label {\n    font-size: 16px;\n    font-weight: 500;\n    max-width: 100%;\n}\n\n.labelFullWidth {\n    max-width: 100%;\n}\n\n.inputWrapper {\n    position: relative;\n    margin: auto 0;\n    flex: 1;\n    display: flex;\n}\n\n.inputWrapper:after {\n    content: attr(data-title);\n    position: absolute;\n    margin: auto;\n    left: 0;\n    right: 0;\n    bottom: 102%;\n    background: #7b848e;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n    color: #fff;\n    width: max-content;\n    max-width: 100%;\n    opacity: 0;\n    font-size: 10px;\n    /*transition: opacity 0.25s ease-in-out;*/\n}\n\n.activeTitle .inputWrapper:after {\n    padding: 2px 4px;\n}\n\n.active .inputWrapper:hover:after {\n    opacity: 1;\n}\n\n.inputField {\n    --input-h: 44px;\n\n    border: 0.5px dashed #707070;\n    border-radius: 2px;\n    padding: 0 15px;\n    line-height: 35px;\n\n    /*padding: 13.5px 14px 13.5px 22px;*/\n    min-height: var(--input-h) !important;\n    max-height: var(--input-h);\n    background-color: #fff;\n    text-align: left;\n    position: relative;\n    /*max-width: 430px;*/\n    width: 100%;\n}\n\n.inputField.readOnlySecondary[readonly] {\n    border: 0.5px dashed #707070;\n}\n\n.inputField:not(.readOnlySecondary)[readonly] {\n    border: 1px solid var(--primary-color-active);\n}\n\n.selectField {\n    border: 0.5px solid #707070;\n    border-radius: 2px;\n    padding: 0 15px;\n    line-height: 35px;\n\n    /*padding: 13.5px 14px 13.5px 22px;*/\n    min-height: var(--input-h) !important;\n    max-height: var(--input-h);\n    background-color: #fff;\n    text-align: left;\n    position: relative;\n    /*max-width: 430px;*/\n    width: 100%;\n}\n\n.inputField:not(.inputFieldTextView):not(textarea),\ntextarea.readOnly {\n    cursor: pointer !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.inputField.selected:not(.focused) {\n    border-color: var(--primary-color-active);\n}\n\n.container.active .inputField {\n    /*border-color: var(--primary-color-active);*/\n}\n\n.inputField:not(.focused):not(.selected) {\n    /*background-color: rgba(214, 214, 214, 0.1) !important;*/\n}\n\n.selectField.focused {\n    border-radius: 0;\n    color: #7b848e;\n}\n\n.inputField.selected.selectedMulti:not(.focused) {\n    background-color: #f0f3f7;\n    color: var(--primary-color-active);\n}\n\n.inputField.multi {\n}\n\n.inputField.disabled,\n.inputField:disabled {\n    color: var(--light-grey);\n    border-color: var(--light-grey) !important;\n    background-color: rgba(214, 214, 214, 0.1);\n}\n\n.inputField:not(.disabled) svg {\n    color: var(--primary-color-active);\n}\n\n.inputWithNote {\n    padding-right: 75px;\n}\n\n.inputNote {\n    position: absolute;\n    right: 40%;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    height: 14px;\n    color: var(--dark-grey);\n}\n\n.icon {\n    position: absolute;\n    left: 15px;\n    top: 12px;\n    width: 20px;\n}\n\n.iconRight {\n    left: auto;\n    right: 10px;\n}\n\n.container.secondary .inputField {\n    /*background: #efeff0;*/\n}\n\n.container.textStyle .inputWrapper {\n    width: 100%;\n    max-width: 100%;\n    overflow: hidden;\n}\n\n.container.textStyle .inputField {\n    border-style: dotted;\n    /*line-height: 40px;*/\n    /*background-image: radial-gradient(#707070 2px, transparent 0);*/\n    /*background-size: 2px 2px;*/\n    /*background-position: -19px -19px;*/\n\n    /*line-height: 24px;*/\n    /*font-size: 16px;*/\n    /*background-image: radial-gradient(circle at 0px 100%, rgb(0, 0, 0) 1px, transparent 1px);*/\n    /*background-size: 6px 34px;*/\n\n    /*background-image: url('../../assets/icons/dot.svg'), linear-gradient(to right, #707070 52px, transparent);*/\n\n    /* Control pattern repetition and positioning */\n    /*background-size: 6px 24px; !* 6px = horizontal dot spacing, 24px = line height *!*/\n    /*background-position: 50px 0; !* Start pattern after 50px white space *!*/\n    /*background-repeat: repeat;*/\n\n    resize: none;\n    /*height: 40px;*/\n    /*min-height: 120px;*/\n    max-height: unset;\n    padding-left: 50px;\n    width: 100%;\n    line-height: 35px;\n}\n\n.container.textStyle .bg,\n.container.textPreview .bg {\n    position: absolute;\n    display: block;\n    top: 34px;\n    left: 50px;\n    width: calc(100% - 50px);\n    height: 100%;\n    background-image: radial-gradient(circle at 0.5px 0.5px, #7b848e 0.5px, transparent 0);\n    background-size: 3px 35px;\n    background-repeat: repeat;\n    pointer-events: none;\n}\n\n.container.textPreview .bg {\n    left: 10px;\n}\n\n.container.textPreview {\n    overflow: hidden;\n}\n\ntextarea.inputField {\n    white-space: pre-wrap;\n}\n\n.note {\n    display: block;\n    text-align: right;\n    font-size: 16px;\n    color: #7b848e;\n    position: absolute;\n    bottom: -18px;\n    right: 0;\n}\n\n.max {\n    display: grid;\n    width: 100%;\n    text-align: right;\n    font-size: 16px;\n    color: #707070;\n    grid-template-columns: 120px 120px;\n    justify-content: flex-end;\n}\n\n.max span:first-child {\n    text-align: left;\n}\n\n.info {\n    margin: 0 0 0 auto;\n    max-width: 300px;\n    font-size: 14px;\n}\n\n.align-top {\n    align-items: flex-start;\n}\n\n.align-top .label {\n    margin-top: 12px;\n}\n\n.inputField.controlTop {\n    z-index: 11;\n    border-top-color: #fff;\n}\n\n.inputField.controlBottom {\n    z-index: 11;\n    border-bottom-color: #fff;\n}\n\n.selectField.focused::after {\n    content: '';\n    display: block;\n    border-top: 1px solid var(--light-grey);\n    position: absolute;\n    bottom: 0;\n    width: calc(100% - 6px);\n    left: 3px;\n}\n\n.selectField.controlTop::after {\n    bottom: initial;\n    top: 0;\n}\n\n.inputFieldTextView {\n    text-wrap: wrap;\n    background-image: radial-gradient(circle at 0.5px 0.5px, #7b848e 0.5px, transparent 0);\n    background-size: 3px 35px;\n    background-repeat: repeat;\n    background-position: 0 34px;\n}\n\n.inputFieldViewContainer {\n    overflow: auto;\n    max-height: calc(100vh - var(--header-height) - 500px);\n}\n\n.inputFieldTextPreview {\n    padding-top: 2px;\n    padding-right: 40px;\n}\n\n.inputFieldTextPreview.selected {\n}\n\n.inputFieldTextPreviewSmall.selected {\n    font-size: 12px;\n    line-height: 16px;\n    padding-top: 6px;\n    padding-bottom: 6px;\n}\n\n@media screen-md-max {\n    .inputFieldTextPreview {\n        padding-top: 0;\n    }\n\n    .container.offset\n    /*:not(:last-child) */ {\n        margin-bottom: 16px;\n    }\n\n    .container:not(.extended):not(.textStyle):not(.hasInfo):not(.secondary) {\n        max-width: 442px;\n    }\n\n    .container:not(.extended):not(.textStyle) .inputWrapper {\n        max-width: 300px;\n    }\n\n    .inputField {\n        --input-h: 32px;\n        /*min-height: 32px !important;*/\n        /*max-height: 32px;*/\n        /*padding: 12px 14px 12px 22px;*/\n        /*padding: 10px 14px 10px 22px;*/\n        font-size: 14px;\n        line-height: 30px;\n    }\n\n    .note {\n        font-size: 14px;\n    }\n\n    .container.offset {\n        margin-bottom: 26px;\n    }\n\n    .icon {\n        top: 6px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"container": `Input_container__3fyBr`,
	"fullWidth": `Input_fullWidth__60kAn`,
	"textStyle": `Input_textStyle__nxjpe`,
	"secondary": `Input_secondary__ni-H-`,
	"afterInput": `Input_afterInput__fajK1`,
	"offset": `Input_offset__M5A7P`,
	"inputWrapper": `Input_inputWrapper__oK-5b`,
	"small": `Input_small__dvTS7`,
	"hasInfo": `Input_hasInfo__-iNkE`,
	"extended": `Input_extended__UkVEC`,
	"full": `Input_full__dYpPd`,
	"label": `Input_label__jk8+l`,
	"label-sm": `Input_label-sm__l2lGp`,
	"labelInner": `Input_labelInner__GpvUH`,
	"afterLabel": `Input_afterLabel__ywMS-`,
	"labelFullWidth": `Input_labelFullWidth__yeP5E`,
	"activeTitle": `Input_activeTitle__opnwL`,
	"active": `Input_active__UMLHi`,
	"inputField": `Input_inputField__lQUCD`,
	"readOnlySecondary": `Input_readOnlySecondary__tD8Cc`,
	"selectField": `Input_selectField__Oy5S1`,
	"inputFieldTextView": `Input_inputFieldTextView__ZRfIt`,
	"readOnly": `Input_readOnly__MPzMO`,
	"selected": `Input_selected__0b6DD`,
	"focused": `Input_focused__LUBdd`,
	"selectedMulti": `Input_selectedMulti__lLnq3`,
	"multi": `Input_multi__YVRas`,
	"disabled": `Input_disabled__lUbIG`,
	"inputWithNote": `Input_inputWithNote__2Y9Ej`,
	"inputNote": `Input_inputNote__1+LwH`,
	"icon": `Input_icon__UofWR`,
	"iconRight": `Input_iconRight__4Bnik`,
	"bg": `Input_bg__SZDbl`,
	"textPreview": `Input_textPreview__NermP`,
	"note": `Input_note__pleid`,
	"max": `Input_max__lThOe`,
	"info": `Input_info__806YQ`,
	"align-top": `Input_align-top__dUN7V`,
	"controlTop": `Input_controlTop__magQr`,
	"controlBottom": `Input_controlBottom__VFaQV`,
	"inputFieldViewContainer": `Input_inputFieldViewContainer__xtQp+`,
	"inputFieldTextPreview": `Input_inputFieldTextPreview__TpCdG`,
	"inputFieldTextPreviewSmall": `Input_inputFieldTextPreviewSmall__YL2Fy`
};
export default ___CSS_LOADER_EXPORT___;
